export const NL_SECURITY_CERTIFICATE = {
  logo: 'thuiswinkel-logo.svg',
  title: 'thuiswinkel',
  url: 'https://www.thuiswinkel.org/leden/raisin-nl/certificaat',
};
